import { defineStore } from 'pinia'
import { ref } from 'vue'
import Lenis from 'lenis'

export const useLenisStore = defineStore('lenis', () => {
  const lenis = ref<Lenis | null>(null)

  function scrollTo(
    to: Parameters<Lenis['scrollTo']>[0],
    options?: Parameters<Lenis['scrollTo']>[1]
  ) {
    if (!lenis.value) return
    lenis.value.scrollTo(to, options)
  }

  function initLenis() {
    lenis.value = new Lenis({
      autoRaf: true,
      anchors: true,
      duration: 1.2,
      easing: t => Math.min(1, 1.001 - Math.pow(2, -20 * t)), // Formule de lissage standard
      smoothWheel: true,
      wheelMultiplier: 1,
      lerp: 0.1,
      infinite: false,
      allowNestedScroll: true
    })
  }

  return { lenis, scrollTo, initLenis }
})
